export default {"src":"/_next/static/media/ExternalTroubleSupportIcon.8a897616.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};